const getImageValue = (list, variety) => {
    const target = list.find((item) => {
        return item.variety === variety;
    });
    return target ? target.source : '';
};

export default getImageValue;
